/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ObjectResponseDto } from '../models/ObjectResponseDto';
import type { StaffLoginDto } from '../models/StaffLoginDto';
import type { StaffLogoutDto } from '../models/StaffLogoutDto';
import type { StaffRefreshDto } from '../models/StaffRefreshDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StaffService {
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAuthControllerLogin({
        requestBody,
    }: {
        requestBody: StaffLoginDto,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/auth/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAuthControllerRefresh({
        requestBody,
    }: {
        requestBody: StaffRefreshDto,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/auth/refresh',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAuthControllerLogout({
        requestBody,
    }: {
        requestBody: StaffLogoutDto,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/auth/logout',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAuthControllerMe(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/auth/me',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerDashboard(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/dashboard',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerListCompanies({
        search,
        status,
        tariff,
    }: {
        search: string,
        status: string,
        tariff: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/companies',
            query: {
                'search': search,
                'status': status,
                'tariff': tariff,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerCompanyDetail({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/companies/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerUpdateCompany({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staff/admin/companies/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerCompanyMembers({
        id,
        search,
    }: {
        id: string,
        search: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/companies/{id}/members',
            path: {
                'id': id,
            },
            query: {
                'search': search,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerListUsers({
        search,
    }: {
        search: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/users',
            query: {
                'search': search,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerBlockUser({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staff/admin/users/{id}/block',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerUnblockUser({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staff/admin/users/{id}/unblock',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerListStaff({
        search,
    }: {
        search: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/staff',
            query: {
                'search': search,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerCreateStaff(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/admin/staff',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerUpdateStaff({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staff/admin/staff/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerResetStaffPassword({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staff/admin/staff/{id}/reset-password',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerListTeams({
        id,
        search,
    }: {
        id: string,
        search: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/companies/{id}/teams',
            path: {
                'id': id,
            },
            query: {
                'search': search,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffAdminControllerTeamDetail({
        id,
        tid,
    }: {
        id: string,
        tid: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/companies/{id}/teams/{tid}',
            path: {
                'id': id,
                'tid': tid,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffBillingControllerListPlans(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/billing/plans',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffBillingControllerCreatePlan(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/admin/billing/plans',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffBillingControllerUpdatePlan({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staff/admin/billing/plans/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffBillingControllerListSubscriptions({
        status,
    }: {
        status: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/billing/subscriptions',
            query: {
                'status': status,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffBillingControllerCompanyBilling({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/billing/companies/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffBillingControllerSubscribe({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/admin/billing/companies/{id}/subscribe',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffBillingControllerListPayments({
        status,
    }: {
        status: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/billing/payments',
            query: {
                'status': status,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffBillingControllerCreatePayment(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/admin/billing/payments',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffBillingControllerUpdatePayment({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staff/admin/billing/payments/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffCreditsControllerListPackages({
        type,
    }: {
        type: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/credits/packages',
            query: {
                'type': type,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffCreditsControllerCreatePackage(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/admin/credits/packages',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffCreditsControllerUpdatePackage({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staff/admin/credits/packages/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffCreditsControllerGetBalance({
        companyId,
    }: {
        companyId: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/credits/balance/{companyId}',
            path: {
                'companyId': companyId,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffCreditsControllerListBalances(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/credits/balances',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffCreditsControllerListTransactions({
        companyId,
    }: {
        companyId: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/credits/transactions',
            query: {
                'companyId': companyId,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffCreditsControllerPurchase(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/admin/credits/purchase',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffCreditsControllerGift(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/admin/credits/gift',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffCreditsControllerListSettings(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/credits/settings',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffCreditsControllerUpdateSetting({
        key,
    }: {
        key: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staff/admin/credits/settings/{key}',
            path: {
                'key': key,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffPromoControllerList(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/promo',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffPromoControllerCreate(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/admin/promo',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffPromoControllerUpdate({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staff/admin/promo/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffPromoControllerRemove({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/staff/admin/promo/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffPromoControllerListUses({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff/admin/promo/{id}/uses',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static staffPromoControllerApply(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staff/admin/promo/apply',
        });
    }
}
